import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ConverterService,
  GlobalMessageService,
  GlobalMessageType,
  OccEndpointsService,
  UserIdService
} from '@spartacus/core'
import { of } from 'rxjs'
import { MbCartMigrationAdapter } from '../connectors'
import { MbCartMigrationContext } from '../../models'
import { ActiveCartService } from '@spartacus/cart/base/core'

@Injectable({
  providedIn: 'root'
})
export class MbOccCartMigrationAdapter implements MbCartMigrationAdapter {

  constructor (protected http: HttpClient,
               protected occEndpoints: OccEndpointsService,
               protected converter: ConverterService,
               protected activeCartService: ActiveCartService,
               protected userIdService: UserIdService,
               protected globalMessageService: GlobalMessageService) {
  }

  post (userID: string, cartMigrationInfo: MbCartMigrationContext) {
    if (userID) {
      return this.http.post(this.getEndpoint(userID), cartMigrationInfo)
    } else {
      this.globalMessageService.add({ key: 'httpHandlers.cartNotFound' }, GlobalMessageType.MSG_TYPE_ERROR)
      return of({})
    }
  }

  protected getEndpoint (userId: string) {
    return this.occEndpoints.buildUrl('cartMigration', {
      urlParams: { userId }
    })
  }
}
